<template>
  <section class="section home-product-categories-wrapper">
    <div class="container">
      <div class="product-category-block">
        <h3 class="title">Explore Products</h3>
        <div class="slider-wrapper">
          <carousel
            :autoplay="false"
            :nav="true"
            :items="6"
            :dots="false"
            :margin="5"
            :responsive="{ 0:{items:1,nav:false}, 600:{items:2,nav:false}, 991:{items:5,nav:false}, 1024:{items: 5,nav:false }, 1368:{items: 5,nav:false}, }"
          >
            <div v-for="product in products" v-bind:key="product.id" class="recommend-items">
              <div class="category-block">
                <!-- <router-link :to="'search/product/solei/'+product.slug"> -->
                <router-link  :to="{ name: 'SearchProductResult',params:{ store_slug: vg_selectedLocation.slug },   query: { product_form: product.slug } }" >
                  <div class="category-image">
                    <img :src="product.image" alt="Category Image" />
                  </div>
                  <h2 class="category-name has-text-black">
                    {{ product.name }}
                  </h2>
                </router-link>
              </div>
            </div>
            <template slot="prev">
              <a class="nav-button button-prev">
                <img src="@/assets/img/icon-nav-arrow-left.svg" alt="prev" />
              </a>
            </template>
            <template slot="next">
              <a class="nav-button button-next">
                <img src="@/assets/img/icon-nav-arrow-right.svg" alt="next" />
              </a>
            </template>
          </carousel>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { isEmpty } from "lodash";
import carousel from "vue-owl-carousel";
export default {
  components: { carousel },
  data() {
    return {
      products: [
        {
          id: 1,
          name: "Dried Flower",
          image: require("@/assets/img/icon-item-dried-flower.svg"),
          slug: "dried flower"
        },
        {
          id: 2,
          name: "Pre-rolled",
           image: require("@/assets/img/icon-item-pre-rolled.svg"),
          slug: "pre rolled"
        },
        {
          id: 3,
          name: "Oil",
          image: require("@/assets/img/icon-item-oil.svg"),
          slug: "oil"
        },
        {
          id: 4,
          name: "Spray",
          image: require("@/assets/img/icon-item-spray.svg"),
          slug: "spray"
        },
        {
          id: 5,
          name: "Capsule",
          image: require("@/assets/img/icon-item-capsule.svg"),
          slug: "capsules"
        },
      ]
    };
  },
  
  computed:{
    ...mapGetters({
      vg_selectedLocation: "location/selected",
    }),
  },

};
</script>
<style >
.slider-wrapper .owl-carousel .owl-item img {
  display: inline-block;
  width: auto !important;
}
.product-category-block .slider-wrapper .owl-carousel .owl-item img {
  width: 35px !important;
  height: 35px !important;
}
.recommend-items {
  padding: 8px 4px;
}
.mt-3{
  margin-top: 25px;
}

@media only screen and (min-width: 992px) {
  .home-product-categories-wrapper .nav-button.button-next{
   display: none !important;
  }
}

</style>